import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import NewHeader from "../Header/NewHeader";
import NewFooter from "../Footer/NewFooter";
import Typewriter from "typewriter-effect";
import { FaPlay } from "react-icons/fa";

gsap.registerPlugin(ScrollTrigger);

const OurServices = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  const sectionsRef = useRef([]);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useEffect(() => {
    sectionsRef.current.forEach((section) => {
      // Animate texts
      const texts = section.querySelectorAll("p, h2, h3");
      gsap.fromTo(
        texts,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          stagger: 0.4,
          ease: "power2.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none none",
          },
        }
      );

      // images
      const images = section.querySelectorAll("img");
      images.forEach((img) => {
        gsap.fromTo(
          img,
          { opacity: 0, y: 50 },
          {
            opacity: 1,
            y: 0,
            duration: 1.2,
            ease: "power2.out",
            scrollTrigger: {
              trigger: img,
              start: "top 85%",
              toggleActions: "play none none none",
            },
          }
        );
      });
    });
  }, []);

  return (
    <div className="w-full">
      {/* Desktop  */}
      <div className="hidden lg:block bg-[#f5f2f0] overflow-x-hidden">
        {/* <header className="fixed top-0 left-0 w-full z-20 bg-transparent">
            <div className="max-w-[1600px] mx-auto flex items-center justify-between py-4 px-10 xl:px-20 2xl:px-32">
              
              <a href ="/HomePage">
                      <img
                      src="../assets/Logo2.png"
                      alt="Logo"
                      className="h-10 cursor-pointer" />
              </a>

              <div className="flex items-start space-x-16">
               
                <nav className="flex flex-col text-[13px] tracking-[0.3em] text-[#948A78] uppercase space-y-5">
                  <a href ="/OurPhilosophy" className="hover:text-[#948A78] transition">
                    Our Philosophy
                  </a>
                  <a href ="/OurSpaces" className="hover:text-[#948A78] transition">
                    Our Spaces
                  </a>
                  <a href ="/OurServices" className="hover:text-[#948A78] transition">
                    Our Services
                  </a>
                </nav>

                <a
                  href="/BookNow"
                  className="hidden lg:inline-block px-3 py-1 text-[13px] text-[#4F423B] tracking-[0.3em] uppercase transition ">
                  Book Now!
                </a>
              </div>
            </div>
          </header> */}
        <NewHeader />

        <div className="pt-[10px]"></div>

        {/* Section 1 */}
        <section
          ref={addToRefs}
          className="bg-[#f5f2f0] text-[#948A78] py-24 px-10 xl:px-20 2xl:px-32 mt-[90px]"
        >
          <div className="max-w-[1600px] mx-auto">
            <div className="mb-16">
              <div className="flex items-start gap-1 mb-8">
                <h2 className="text-[20px] leading-tight xl:ml-44 2xl:ml-28 lg:ml-32 text-right">
                  Our <br />
                  Spaces
                </h2>
              </div>

              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-10">
                <p className="max-w-[360px] leading-relaxed text-[13px] text-[#948A78] xl:ml-[38vh] lg:ml-[35vh] 2xl:ml-[15vh]">
                  Five spacious bedrooms. A shimmering pool. A courtyard kissed
                  by the breeze. At House of Tāo, the architecture flows with
                  the land, creating an atmosphere that feels both open and
                  intimate.
                </p>

                <a
                  href="/OurSpaces"
                  className="text-[13px] tracking-[0.15em] uppercase lg:mr-2 xl:mr-10 2xl:mr-44 md:mt-0 mt-6
                    hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                >
                  Explore Our Spaces
                </a>
              </div>
            </div>

            <div className="flex justify-end">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[95rem] w-full lg:w-[78%] xl:mr-7 2xl:mr-40">
                <div className="w-full">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/00ec53dd-09f5-4c5a-7d55-2d0556aaa000/public"
                    alt="Bedroom"
                    className="w-full aspect-[3/2] object-cover transition-transform duration-300"
                  />
                  <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
                    The Bedrooms
                  </h3>
                  <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
                    Minimal yet warm, with natural textures, plush bedding, and
                    large windows that invite the outside in.
                  </p>
                </div>

                <div className="w-full">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3b1cca27-d5ae-4ef1-855c-1c97573c7300/public"
                    alt="Pool & Jacuzzi"
                    className="w-full aspect-[3/2] object-cover shadow-sm transition-transform duration-300"
                  />
                  <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
                    The Pool & Jacuzzi
                  </h3>
                  <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
                    A private retreat framed by greenery, perfect for a morning
                    swim or an evening unwind.
                  </p>
                </div>

                <div className="w-full">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/aa26ac68-9831-4885-8242-0f193f766000/public"
                    alt="Living & Dining"
                    className="w-full aspect-[3/2] object-cover shadow-sm transition-transform duration-300"
                  />
                  <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
                    Living & Dining
                  </h3>
                  <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
                    Open-plan spaces with curated decor, blending modern design
                    with Goan charm.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* section 2 */}
        <section
          ref={addToRefs}
          className="bg-[#f5f2f0] text-[#948A78] py-16 px-6 sm:px-10 lg:px-20 xl:px-32"
        >
          <div className="max-w-[1600px] mx-auto flex flex-col lg:flex-row items-center lg:items-start justify-between gap-12">
            <div className="flex-1 xl:mt-14 2xl:mt-20 3xl:mt-32 4k:mt-40">
              <h2 className="text-[20px] text-right leading-relaxed lg:mr-[26vw] xl:mr-[28vw] 2xl:mr-[27vw] 3xl:mr-[21vw] 4k:mr-[20vw] mb-6">
                Villa Features <br /> & Amenities
              </h2>

              <div className="text-[13px] leading-relaxed lg:ml-[10vw] xl:ml-[12vw] 2xl:ml-[13vw] 3xl:ml-[14vw] 4k:ml-[10vw] lg:w-[280px] xl:w-[320px] 2xl:w-[350px] 3xl:w-[360px] 4k:w-[380px] space-y-4 xl:space-y-6">
                <p>• Private pool & jacuzzi</p>
                <p>• Hi-speed Wi-Fi</p>
                <p>• 100% power backup</p>
                <p>• Daily housekeeping & evening turndown</p>
                <p>
                  • Team of 5 on-site: 1 chef, 1 butler, 2 caretakers, 1 villa
                  manager
                </p>
                <p>• Property manager assistance throughout your stay</p>
              </div>
            </div>

            <div className="flex-1 flex justify-center lg:justify-end">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/87795696-8179-4a27-0ec7-9754e1592000/public"
                alt="Villa Amenities"
                className="object-cover w-full 
                  xl:h-[60vh] lg:max-w-[500px] xl:max-w-[650px] 2xl:max-w-[600px] 3xl:max-w-[650px] 4k:max-w-[80vh] 4k:h-[40vh] xl:-mr-12 lg:-mr-10 4k:mr-10"
              />
            </div>
          </div>
        </section>

        {/* section 3 */}
        <section
          ref={addToRefs}
          className="bg-[#f5f2f0] text-[#948A78] py-16 px-6 sm:px-10 lg:px-20 xl:px-32"
        >
          <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center lg:items-start justify-between gap-16">
            <div className="flex-1 flex justify-end">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/964a5299-9327-40d8-4533-3cd1405bb100/public"
                alt="Inclusions"
                className="lg:w-[300px] xl:w-[350px] h-auto object-cover shadow-sm"
              />
            </div>

            <div className="flex-1 text-left xl:pt-[49vh] lg:pt-[43vh] 4k:pt-[25vh] 2xl:pt-[32vh]">
              <h2 className="text-[20px] mb-8">Inclusions</h2>

              <div className="space-y-5 text-[13px] ml-20 w-[350px] leading-relaxed">
                <p>• Breakfast spread included daily</p>
                <p>• 2 Innovas or 3 small cars for airport transfer</p>
                <p>
                  • Full-day chef service (groceries for meals other than
                  breakfast at actuals)
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* section 4 */}
        <section className="relative w-screen h-[90vh] overflow-hidden bg-[#f5f2f0] mt-32 mb-32">
          {/* <img
            src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f817e156-399b-4cf9-6f16-c86e16ca4900/public" // Tao_ourServices_new1.webp
            alt="Harmony with Nature"
            className="w-full h-full object-cover object-center"
          /> */}

          {!isPlaying && (
            <>
              <img
                src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f817e156-399b-4cf9-6f16-c86e16ca4900/public" // Tao_ourServices_new1.webp
                alt="Harmony with Nature"
                className="w-full h-full object-cover object-center cursor-pointer"
                onClick={() => setIsPlaying(true)}
              />

              <div
                className="absolute inset-0 bg-black/0 cursor-pointer"
                onClick={() => setIsPlaying(true)}
              />

              <div
                className="absolute inset-0 flex items-center justify-center cursor-pointer"
                onClick={() => setIsPlaying(true)}
              >
                <div className="inline-block bg-white/0 p-5 rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
                  <div className="bg-white/70 p-4 rounded-full shadow-lg">
                    <FaPlay className="text-[#948A78] p-2 pl-3 text-4xl" />
                  </div>
                </div>
              </div>
            </>
          )}

          {isPlaying && (
            <iframe
              className="absolute top-0 left-0 w-full h-full"
              src="https://www.youtube.com/embed/H6u9yKWoixY?autoplay=1"
              title="YouTube video player"
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
            />
          )}
        </section>

        {/* section 5 */}
        <section
          ref={addToRefs}
          className="bg-[#f5f2f0] py-16 px-4 sm:px-6 lg:px-8"
        >
          <div className="max-w-7xl mx-auto">
            {/* Heading */}
            <div className="text-center lg:text-left mb-6 ml-36">
              <h2 className="text-[13px] tracking-[0.13em] text-[#948A78] uppercase mb-4">
                OUR EXPERIENCES
              </h2>
              <p className="w-[320px] text-[#948A78] leading-relaxed mx-auto lg:mx-0 text-[13px]">
                Your time at House of Tao is more than a stay – it's a
                collection of moments you'll carry home. From quiet moments to
                curated adventures, we help you shape experiences as unique as
                you are.
              </p>
            </div>

            <div className="flex flex-col lg:flex-row lg:space-x-12">
              <div className="lg:w-3/5 mb-8 lg:mb-0">
                <div className="bg-[#f5f2f0] flex justify-center">
                  <img
                    src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/454164e8-4047-4f03-717d-2463f613aa00/public" // Tao_ourServices_new2.webp
                    alt="Elegant dining table setup in the villa"
                    className="object-cover mx-auto 
                              w-[80vw] max-w-[900px] xl:mr-16 lg:-ml-5
                              lg:w-[50vw] xl:w-[45vw] 2xl:w-[50vw] 3xl:w-[45vw] 4k:w-[40vw]
                              h-[60vh] lg:h-[70vh] xl:h-[70vh] 2xl:h-[70vh] 3xl:h-[65vh] 4k:h-[50vh]"
                  />
                </div>

                <div className="py-6 px-4 mt-10 ml-[40vh] 2xl:ml-[20vh] lg:ml-[12vh]">
                  <p className="w-[350px] text-[#948A78] leading-relaxed text-[13px] mb-7">
                    Whether you're planning your next getaway, looking for a
                    special celebration venue, or simply curious to know more –
                    we'd love to hear from you.
                  </p>

                  <a
                    href="/BookNow"
                    className="relative text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-1 
                    hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
                  >
                    BOOK YOUR STAY
                  </a>
                </div>
              </div>

              <div className="lg:w-2/5 flex flex-col lg:space-y-2 xl:space-y-8 text-[#948A78] 4k:mt-40 2xl:mt-20">
                <div className="ml-20">
                  <h3 className="text-[20px] mb-4 -ml-[18vh] 4k:ml-14 2xl:ml-14 2xl:mb-10">
                    In the Villa
                  </h3>

                  <div className="list-none xl:space-y-6 lg:space-y-3 text-[13px] pl-0 4k:ml-40 2xl:ml-44">
                    <p>• Signature breakfast spread by our in-house chef</p>
                    <p>• Two-course dinners crafted to your taste</p>
                    <p>• Floating brunch by the pool</p>
                    <p>• Private barbecues under the stars</p>
                  </div>
                </div>

                <div className="space-y-6 pt-4 text-[20px] xl:-ml-[49vh] lg:-ml-[53vh] w-[400px] 4k:-ml-[9vh] 2xl:-ml-[15vh] text-right text-[#BFB5A3]">
                  <h2>
                    Wellness & <br />
                    Retreats
                  </h2>
                  <h2>
                    Goa Through <br />
                    Our Eyes
                  </h2>
                  <h2>
                    Nature & <br />
                    Outdoors
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </section>
        <NewFooter />
      </div>

      {/*============= Mobile =============== */}
      <div className="flex flex-col lg:hidden text-center relative overflow-x-hidden bg-[#f5f2f0]">
        {/* ---- Section 1 ---- */}
        <div
          className="fixed inset-0 w-full h-full bg-cover bg-center z-0"
          style={{
            backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4538ec43-dac0-4aee-8148-a83526d3af00/public')`, //Tao_ourServices_bannerMobile.webp
          }}
        >
          <div className="absolute inset-0 bg-black/50"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-[14px] tracking-[0.25em] uppercase text-[#F5F2F0] leading-relaxed">
            <Typewriter
              options={{
                delay: 60,
                deleteSpeed: 30,
              }}
              onInit={(typewriter) => {
                typewriter
                  .typeString("Escape. Indulge. Repeat.")
                  .pauseFor(800)
                  .callFunction(() => {
                    const cursor = document.querySelector(
                      ".Typewriter__cursor"
                    );
                    if (cursor) cursor.style.display = "none";
                  })
                  .start();
              }}
            />
          </div>
        </div>

        <div className="relative z-10 pt-[100vh] ">
          {/* header */}
          <NewHeader />

          {/* section 2 */}
          <section
            ref={addToRefs}
            className="bg-[#f5f2f0] py-24 px-4 sm:px-6 lg:px-8"
          >
            <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
              <h2 className="text-[20px] text-[#948A78] mb-8 text-right sm:-mr-[30vh] -ml-[35vh]">
                Our <br />
                Spaces
              </h2>

              <p className="sm:w-[300px] text-[#948A78] text-left leading-relaxed text-[13px] sm:ml-[60vh] w-[250px] ml-14 mb-12">
                Five spacious bedrooms. A shimmering pool. A courtyard kissed by
                the breeze. At House of Tāo, the architecture flows with the
                land, creating an atmosphere that feels both open and intimate.
              </p>

              <a
                href="/OurSpaces"
                className="text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-1 sm:ml-[40vh] -ml-8 mb-32
                hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
              >
                EXPLORE OUR SPACES
              </a>

              <div className="max-w-xl w-full">
                <div className="mb-8 relative">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/00ec53dd-09f5-4c5a-7d55-2d0556aaa000/public" // Tao_ourSpaces_3.webp
                    alt="Minimal yet warm bedroom in the villa"
                    className="sm:w-[65vh] h-auto sm:-ml-14 w-[50vh] -ml-1 object-cover"
                  />
                </div>

                <div className="flex flex-col sm:flex-col items-start sm:items-start gap-4 sm:ml-24 ml-28">
                  <h3 className="text-[13px] tracking-[0.25em] text-[#948A78] uppercase">
                    THE BEDROOMS
                  </h3>

                  <p className="text-[#948A78] text-[13px] sm:w-[250px] w-[200px] text-left">
                    Minimal yet warm, with natural textures, plush bedding, and
                    large windows that invite the outside in.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* section 3 */}
          <section ref={addToRefs} className="bg-[#f5f2f0] py-10 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="flex flex-col lg:flex-row sm:items-end items-start gap-6 px-6 sm:px-10 lg:px-20">
                <div className="lg:w-1/3 sm:mr-[60vh]">
                  <h2 className="text-[20px] text-[#948A78]">
                    Villa Features <br /> & Amenities
                  </h2>
                </div>

                <div className="lg:w-2/3 text-left ml-20">
                  <div className="space-y-8 text-[#948A78] text-[13px]">
                    <p className="flex items-start">• Private pool & jacuzzi</p>
                    <p className="flex items-start">• Hi-speed Wi-Fi</p>
                    <p className="flex items-start">• 100% power backup</p>
                    <p className="flex items-start">
                      • Daily housekeeping & evening turndown
                    </p>
                    <p className="flex items-start">
                      • Team of 5 on-site: 1 chef, 1 butler, 2 caretakers, 1
                      villa manager
                    </p>
                    <p className="flex items-start">
                      • Property manager assistance throughout your stay
                    </p>
                  </div>
                </div>

                <div className=" self-end -mr-24 sm:-mr-40 relative mt-10 mb-10">
                  <img
                    src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/964a5299-9327-40d8-4533-3cd1405bb100/public" //Tao_ourServices_5.webp
                    alt="Indoor bar area with seating"
                    className="w-[55vh] sm:w-[70vh] h-[70vh] sm:h-[80vh] object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* section 4 */}
          <div className="bg-[#f5f2f0]">
            <div
              ref={addToRefs}
              className="text-left text-[13px] space-y-10 text-[#948A78] ml-[12vh] sm:ml-[35vh] sm:w-[250px] items-center"
            >
              <h2 className="text-[20px] tracking-wide text-right mb-2 -ml-10 sm:ml-7 w-[100px] ">
                Inclusions
              </h2>

              <div className="leading-relaxed text-[13px] space-y-8 text-left sm:w-[270px] w-[200px] ml-[5vh] sm:ml-24">
                <p className="mb-4">• Breakfast spread included daily</p>
                <p>• 2 Innovas or 3 small cars for airport transfer</p>
                <p>
                  • Full-day chef service (groceries for meals other than
                  breakfast at actuals)
                </p>
              </div>
            </div>
          </div>
          {/* section 5 */}

          <section
            id="section4"
            className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0]"
          >
            {/* <div className="w-full flex justify-center mt-24">
              <img
                src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f817e156-399b-4cf9-6f16-c86e16ca4900/public" // Tao_ourServices_new1.webp
                alt="Modern Architecture"
                className="w-full h-auto object-cover transition-all duration-500"
              />
            </div> */}

            <div className="w-full h-[70vh] flex justify-center mt-24 relative">
              {!isPlaying && (
                <>
                  <img
                    src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/f817e156-399b-4cf9-6f16-c86e16ca4900/public" // Tao_ourServices_new1.webp
                    alt="Modern Architecture"
                    className="w-full h-auto object-cover transition-all duration-500 cursor-pointer"
                    onClick={() => setIsPlaying(true)}
                  />

                  <div
                    className="absolute inset-0 bg-black/0 cursor-pointer"
                    onClick={() => setIsPlaying(true)}
                  />

                  <div
                    className="absolute inset-0 flex items-center justify-center cursor-pointer"
                    onClick={() => setIsPlaying(true)}
                  >
                    <div className="inline-block bg-white/0 p-5 rounded-full hover:scale-110 transition-transform duration-200 ease-in-out">
                      <div className="bg-white/70 p-4 rounded-full shadow-lg">
                        <FaPlay className="text-[#948A78] p-2 pl-3 text-4xl" />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {isPlaying && (
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/H6u9yKWoixY?autoplay=1"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                />
              )}
            </div>
          </section>

          {/* section 6 */}
          <div className="bg-[#f5f2f0] h-20 pt-10">
            <div
              ref={addToRefs}
              className=" text-[13px] space-y-3 text-[#948A78] ml-5 sm:w-[250px]"
            >
              <h2 className="text-[13px] tracking-[0.20em] text-left mt-20 w-[300px] uppercase">
                our experiences
              </h2>

              <div className="leading-relaxed text-[13px] space-y-6 text-left sm:w-[400px] w-[300px]">
                <p className="mb-4">
                  Your time at House of Tāo is more than a stay — it’s a
                  collection of moments you’ll carry home. From quiet mornings
                  to curated adventures, we help you shape experiences as unique
                  as you are.
                </p>
              </div>
            </div>
          </div>

          {/* section 7 */}

          <section
            ref={addToRefs}
            className="bg-[#f5f2f0] text-[#948A78] py-60 px-6 sm:px-12"
          >
            <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-16">
              <div className="flex-1 flex flex-col text-right">
                <div className="grid grid-cols-2 gap-x-4 gap-y-4 justify-items-center lg:justify-items-start text-[20px]">
                  <p className="text-[#948A78]">In the Villa</p>
                  <p className="text-[#BFB5A3]">
                    Goa Through <br /> Our Eyes
                  </p>
                  <p className="text-[#BFB5A3]">
                    Wellness & <br /> Retreats
                  </p>
                  <p className="text-[#BFB5A3]">
                    Nature & <br /> Outdoors
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 items-center justify-between gap-0">
                <div className="w-[100vh]">
                  <img
                    src="https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/454164e8-4047-4f03-717d-2463f613aa00/public" // Tao_ourServices_new2.webp
                    alt="Villa Dining Experience"
                    className="w-[27vh] sm:w-[55vh] h-[50vh] sm:h-[70vh] object-cover -ml-6 sm:-ml-14"
                  />
                </div>

                <div className="w-full lg:w-1/2 text-[13px] text-left space-y-4 mt-20 sm:mt-36 ml-7">
                  <div className="space-y-4 sm:space-y-10">
                    <p>• Signature breakfast spread by our in-house chef</p>
                    <p>• Two-course dinners crafted to your taste</p>
                    <p>• Floating brunch by the pool</p>
                    <p>• Private barbecues under the stars</p>
                  </div>
                </div>
              </div>

              <p className="sm:w-[350px] text-[#948A78] text-left text-[13px] sm:ml-[30vh] w-[250px] ml-12">
                Whether you’re planning your next getaway, looking for a special
                celebration venue, or simply curious to know more — we’d love to
                hear from you.
              </p>

              <a
                href="/BookNow"
                className="text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-10 sm:-ml-7 -ml-20 -mb-40 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
              >
                BOOK YOUR STAY
              </a>
            </div>
          </section>
          <NewFooter />
        </div>
      </div>
    </div>
  );
};

export default OurServices;

// import React, { useEffect, useRef } from "react";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import NewHeader from "../Header/NewHeader";
// import NewFooter from "../Footer/NewFooter";
// import Typewriter from "typewriter-effect";

// gsap.registerPlugin(ScrollTrigger);

// const OurServices = () => {
//   const sectionsRef = useRef([]);

//   const addToRefs = (el) => {
//     if (el && !sectionsRef.current.includes(el)) {
//       sectionsRef.current.push(el);
//     }
//   };

//   useEffect(() => {
//     sectionsRef.current.forEach((section) => {
//       // Animate texts
//       const texts = section.querySelectorAll("p, h2, h3");
//       gsap.fromTo(
//         texts,
//         { opacity: 0, y: 50 },
//         {
//           opacity: 1,
//           y: 0,
//           duration: 1,
//           stagger: 0.4,
//           ease: "power2.out",
//           scrollTrigger: {
//             trigger: section,
//             start: "top 80%",
//             toggleActions: "play none none none",
//           },
//         }
//       );

//       // images
//       const images = section.querySelectorAll("img");
//       images.forEach((img) => {
//         gsap.fromTo(
//           img,
//           { opacity: 0, y: 50 },
//           {
//             opacity: 1,
//             y: 0,
//             duration: 1.2,
//             ease: "power2.out",
//             scrollTrigger: {
//               trigger: img,
//               start: "top 85%",
//               toggleActions: "play none none none",
//             },
//           }
//         );
//       });
//     });
//   }, []);

//   return (
//     <div className="w-full">
//       {/* Desktop  */}
//       <div className="hidden lg:block bg-[#f5f2f0] overflow-x-hidden">
//         {/* <header className="fixed top-0 left-0 w-full z-20 bg-transparent">
//             <div className="max-w-[1600px] mx-auto flex items-center justify-between py-4 px-10 xl:px-20 2xl:px-32">

//               <a href ="/HomePage">
//                       <img
//                       src="../assets/Logo2.png"
//                       alt="Logo"
//                       className="h-10 cursor-pointer" />
//               </a>

//               <div className="flex items-start space-x-16">

//                 <nav className="flex flex-col text-[13px] tracking-[0.3em] text-[#948A78] uppercase space-y-5">
//                   <a href ="/OurPhilosophy" className="hover:text-[#948A78] transition">
//                     Our Philosophy
//                   </a>
//                   <a href ="/OurSpaces" className="hover:text-[#948A78] transition">
//                     Our Spaces
//                   </a>
//                   <a href ="/OurServices" className="hover:text-[#948A78] transition">
//                     Our Services
//                   </a>
//                 </nav>

//                 <a
//                   href="/BookNow"
//                   className="hidden lg:inline-block px-3 py-1 text-[13px] text-[#4F423B] tracking-[0.3em] uppercase transition ">
//                   Book Now!
//                 </a>
//               </div>
//             </div>
//           </header> */}
//         <NewHeader />

//         <div className="pt-[10px]"></div>

//         {/* Section 1 */}
//         <section
//           ref={addToRefs}
//           className="bg-[#f5f2f0] text-[#948A78] py-24 px-10 xl:px-20 2xl:px-32 mt-[90px]"
//         >
//           <div className="max-w-[1600px] mx-auto">
//             <div className="mb-16">
//               <div className="flex items-start gap-1 mb-8">
//                 <h2 className="text-[20px] leading-tight xl:ml-44 2xl:ml-28 lg:ml-32 text-right">
//                   Our <br />
//                   Spaces
//                 </h2>
//               </div>

//               <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-10">
//                 <p className="max-w-[360px] leading-relaxed text-[13px] text-[#948A78] xl:ml-[38vh] lg:ml-[35vh] 2xl:ml-[15vh]">
//                   Five spacious bedrooms. A shimmering pool. A courtyard kissed
//                   by the breeze. At House of Tāo, the architecture flows with
//                   the land, creating an atmosphere that feels both open and
//                   intimate.
//                 </p>

//                 <a
//                   href="/OurSpaces"
//                   className="text-[13px] tracking-[0.15em] uppercase lg:mr-2 xl:mr-10 2xl:mr-44 md:mt-0 mt-6
//                     hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                 >
//                   Explore Our Spaces
//                 </a>
//               </div>
//             </div>

//             <div className="flex justify-end">
//               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-[95rem] w-full lg:w-[78%] xl:mr-7 2xl:mr-40">
//                 <div className="w-full">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/00ec53dd-09f5-4c5a-7d55-2d0556aaa000/public"
//                     alt="Bedroom"
//                     className="w-full aspect-[3/2] object-cover transition-transform duration-300"
//                   />
//                   <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
//                     The Bedrooms
//                   </h3>
//                   <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
//                     Minimal yet warm, with natural textures, plush bedding, and
//                     large windows that invite the outside in.
//                   </p>
//                 </div>

//                 <div className="w-full">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/3b1cca27-d5ae-4ef1-855c-1c97573c7300/public"
//                     alt="Pool & Jacuzzi"
//                     className="w-full aspect-[3/2] object-cover shadow-sm transition-transform duration-300"
//                   />
//                   <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
//                     The Pool & Jacuzzi
//                   </h3>
//                   <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
//                     A private retreat framed by greenery, perfect for a morning
//                     swim or an evening unwind.
//                   </p>
//                 </div>

//                 <div className="w-full">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/aa26ac68-9831-4885-8242-0f193f766000/public"
//                     alt="Living & Dining"
//                     className="w-full aspect-[3/2] object-cover shadow-sm transition-transform duration-300"
//                   />
//                   <h3 className="uppercase text-[13px] tracking-[0.25em] mt-6 mb-3 text-[#948A78]">
//                     Living & Dining
//                   </h3>
//                   <p className="text-[13px] leading-relaxed text-[#948A78] max-w-[320px] ml-24">
//                     Open-plan spaces with curated decor, blending modern design
//                     with Goan charm.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* section 2 */}
//         <section
//           ref={addToRefs}
//           className="bg-[#f5f2f0] text-[#948A78] py-16 px-6 sm:px-10 lg:px-20 xl:px-32"
//         >
//           <div className="max-w-[1600px] mx-auto flex flex-col lg:flex-row items-center lg:items-start justify-between gap-12">
//             <div className="flex-1 xl:mt-14 2xl:mt-20 3xl:mt-32 4k:mt-40">
//               <h2 className="text-[20px] text-right leading-relaxed lg:mr-[26vw] xl:mr-[28vw] 2xl:mr-[27vw] 3xl:mr-[21vw] 4k:mr-[20vw] mb-6">
//                 Villa Features <br /> & Amenities
//               </h2>

//               <div className="text-[13px] leading-relaxed lg:ml-[10vw] xl:ml-[12vw] 2xl:ml-[13vw] 3xl:ml-[14vw] 4k:ml-[10vw] lg:w-[280px] xl:w-[320px] 2xl:w-[350px] 3xl:w-[360px] 4k:w-[380px] space-y-4 xl:space-y-6">
//                 <p>• Private pool & jacuzzi</p>
//                 <p>• Hi-speed Wi-Fi</p>
//                 <p>• 100% power backup</p>
//                 <p>• Daily housekeeping & evening turndown</p>
//                 <p>
//                   • Team of 5 on-site: 1 chef, 1 butler, 2 caretakers, 1 villa
//                   manager
//                 </p>
//                 <p>• Property manager assistance throughout your stay</p>
//               </div>
//             </div>

//             <div className="flex-1 flex justify-center lg:justify-end">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/87795696-8179-4a27-0ec7-9754e1592000/public"
//                 alt="Villa Amenities"
//                 className="object-cover w-full
//                   xl:h-[60vh] lg:max-w-[500px] xl:max-w-[650px] 2xl:max-w-[600px] 3xl:max-w-[650px] 4k:max-w-[80vh] 4k:h-[40vh] xl:-mr-12 lg:-mr-10 4k:mr-10"
//               />
//             </div>
//           </div>
//         </section>

//         {/* section 3 */}
//         <section
//           ref={addToRefs}
//           className="bg-[#f5f2f0] text-[#948A78] py-16 px-6 sm:px-10 lg:px-20 xl:px-32"
//         >
//           <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center lg:items-start justify-between gap-16">
//             <div className="flex-1 flex justify-end">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/964a5299-9327-40d8-4533-3cd1405bb100/public"
//                 alt="Inclusions"
//                 className="lg:w-[300px] xl:w-[350px] h-auto object-cover shadow-sm"
//               />
//             </div>

//             <div className="flex-1 text-left xl:pt-[49vh] lg:pt-[43vh] 4k:pt-[25vh] 2xl:pt-[32vh]">
//               <h2 className="text-[20px] mb-8">Inclusions</h2>

//               <div className="space-y-5 text-[13px] ml-20 w-[350px] leading-relaxed">
//                 <p>• Breakfast spread included daily</p>
//                 <p>• 2 Innovas or 3 small cars for airport transfer</p>
//                 <p>
//                   • Full-day chef service (groceries for meals other than
//                   breakfast at actuals)
//                 </p>
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* section 4 */}
//         <section className="relative w-screen h-screen overflow-hidden bg-[#f5f2f0] mt-32 mb-32">
//           <img
//             src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1902f637-2936-4eeb-3894-b522ca77f200/public"
//             alt="Harmony with Nature"
//             className="w-full h-full object-cover object-center"
//           />
//         </section>

//         {/* section 5 */}
//         <section
//           ref={addToRefs}
//           className="bg-[#f5f2f0] py-16 px-4 sm:px-6 lg:px-8"
//         >
//           <div className="max-w-7xl mx-auto">
//             {/* Heading */}
//             <div className="text-center lg:text-left mb-6 ml-36">
//               <h2 className="text-[13px] tracking-[0.13em] text-[#948A78] uppercase mb-4">
//                 OUR EXPERIENCES
//               </h2>
//               <p className="w-[320px] text-[#948A78] leading-relaxed mx-auto lg:mx-0 text-[13px]">
//                 Your time at House of Tao is more than a stay – it's a
//                 collection of moments you'll carry home. From quiet moments to
//                 curated adventures, we help you shape experiences as unique as
//                 you are.
//               </p>
//             </div>

//             <div className="flex flex-col lg:flex-row lg:space-x-12">
//               <div className="lg:w-3/5 mb-8 lg:mb-0">
//                 <div className="bg-[#f5f2f0] flex justify-center">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/8b07610e-279e-4b32-ac6e-5fe038e07700/public"
//                     alt="Elegant dining table setup in the villa"
//                     className="object-cover mx-auto
//                               w-[80vw] max-w-[900px] xl:mr-16 lg:-ml-5
//                               lg:w-[50vw] xl:w-[45vw] 2xl:w-[50vw] 3xl:w-[45vw] 4k:w-[40vw]
//                               h-[60vh] lg:h-[70vh] xl:h-[70vh] 2xl:h-[70vh] 3xl:h-[65vh] 4k:h-[50vh]"
//                   />
//                 </div>

//                 <div className="py-6 px-4 mt-10 ml-[40vh] 2xl:ml-[20vh] lg:ml-[12vh]">
//                   <p className="w-[350px] text-[#948A78] leading-relaxed text-[13px] mb-7">
//                     Whether you're planning your next getaway, looking for a
//                     special celebration venue, or simply curious to know more –
//                     we'd love to hear from you.
//                   </p>

//                   <a
//                     href="/BookNow"
//                     className="relative text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-1
//                     hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//                   >
//                     BOOK YOUR STAY
//                   </a>
//                 </div>
//               </div>

//               <div className="lg:w-2/5 flex flex-col lg:space-y-2 xl:space-y-8 text-[#948A78] 4k:mt-40 2xl:mt-20">
//                 <div className="ml-20">
//                   <h3 className="text-[20px] mb-4 -ml-[18vh] 4k:ml-14 2xl:ml-14 2xl:mb-10">
//                     In the Villa
//                   </h3>

//                   <div className="list-none xl:space-y-6 lg:space-y-3 text-[13px] pl-0 4k:ml-40 2xl:ml-44">
//                     <p>• Signature breakfast spread by our in-house chef</p>
//                     <p>• Two-course dinners crafted to your taste</p>
//                     <p>• Floating brunch by the pool</p>
//                     <p>• Private barbecues under the stars</p>
//                   </div>
//                 </div>

//                 <div className="space-y-6 pt-4 text-[20px] xl:-ml-[49vh] lg:-ml-[53vh] w-[400px] 4k:-ml-[9vh] 2xl:-ml-[15vh] text-right text-[#BFB5A3]">
//                   <h2>
//                     Wellness & <br />
//                     Retreats
//                   </h2>
//                   <h2>
//                     Goa Through <br />
//                     Our Eyes
//                   </h2>
//                   <h2>
//                     Nature & <br />
//                     Outdoors
//                   </h2>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//         <NewFooter />
//       </div>

//       {/*============= Mobile =============== */}
//       <div className="flex flex-col lg:hidden text-center relative overflow-x-hidden bg-[#f5f2f0]">
//         {/* ---- Section 1 ---- */}
//         <div
//           className="fixed inset-0 w-full h-full bg-cover bg-center z-0"
//           style={{
//             backgroundImage: `url('https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4538ec43-dac0-4aee-8148-a83526d3af00/public')`, //Tao_ourServices_bannerMobile.webp
//           }}
//         >
//           <div className="absolute inset-0 bg-black/50"></div>
//           <div className="absolute inset-0 flex flex-col items-center justify-center text-[14px] tracking-[0.25em] uppercase text-[#F5F2F0] leading-relaxed">
//             <Typewriter
//               options={{
//                 delay: 60,
//                 deleteSpeed: 30,
//               }}
//               onInit={(typewriter) => {
//                 typewriter
//                   .typeString("get lost.")
//                   .pauseFor(800)
//                   .typeString("<br/>feel found.")
//                   .callFunction(() => {
//                     const cursor = document.querySelector(
//                       ".Typewriter__cursor"
//                     );
//                     if (cursor) cursor.style.display = "none";
//                   })
//                   .start();
//               }}
//             />
//           </div>
//         </div>

//         <div className="relative z-10 pt-[100vh] ">
//           {/* header */}
//           <NewHeader />

//           {/* section 2 */}
//           <section
//             ref={addToRefs}
//             className="bg-[#f5f2f0] py-24 px-4 sm:px-6 lg:px-8"
//           >
//             <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
//               <h2 className="text-[20px] text-[#948A78] mb-8 text-right sm:-mr-[30vh] -ml-[35vh]">
//                 Our <br />
//                 Spaces
//               </h2>

//               <p className="sm:w-[300px] text-[#948A78] text-left leading-relaxed text-[13px] sm:ml-[60vh] w-[250px] ml-14 mb-12">
//                 Five spacious bedrooms. A shimmering pool. A courtyard kissed by
//                 the breeze. At House of Tāo, the architecture flows with the
//                 land, creating an atmosphere that feels both open and intimate.
//               </p>

//               <a
//                 href="/OurSpaces"
//                 className="text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-1 sm:ml-[40vh] -ml-8 mb-32
//                 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//               >
//                 EXPLORE OUR SPACES
//               </a>

//               <div className="max-w-xl w-full">
//                 <div className="mb-8 relative">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/00ec53dd-09f5-4c5a-7d55-2d0556aaa000/public" // Tao_ourSpaces_3.webp
//                     alt="Minimal yet warm bedroom in the villa"
//                     className="sm:w-[65vh] h-auto sm:-ml-14 w-[50vh] -ml-1 object-cover"
//                   />
//                 </div>

//                 <div className="flex flex-col sm:flex-col items-start sm:items-start gap-4 sm:ml-24 ml-28">
//                   <h3 className="text-[13px] tracking-[0.25em] text-[#948A78] uppercase">
//                     THE BEDROOMS
//                   </h3>

//                   <p className="text-[#948A78] text-[13px] sm:w-[250px] w-[200px] text-left">
//                     Minimal yet warm, with natural textures, plush bedding, and
//                     large windows that invite the outside in.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* section 3 */}
//           <section ref={addToRefs} className="bg-[#f5f2f0] py-10 px-4 sm:px-6">
//             <div className="max-w-4xl mx-auto">
//               <div className="flex flex-col lg:flex-row sm:items-end items-start gap-6 px-6 sm:px-10 lg:px-20">
//                 <div className="lg:w-1/3 sm:mr-[60vh]">
//                   <h2 className="text-[20px] text-[#948A78]">
//                     Villa Features <br /> & Amenities
//                   </h2>
//                 </div>

//                 <div className="lg:w-2/3 text-left ml-20">
//                   <div className="space-y-8 text-[#948A78] text-[13px]">
//                     <p className="flex items-start">• Private pool & jacuzzi</p>
//                     <p className="flex items-start">• Hi-speed Wi-Fi</p>
//                     <p className="flex items-start">• 100% power backup</p>
//                     <p className="flex items-start">
//                       • Daily housekeeping & evening turndown
//                     </p>
//                     <p className="flex items-start">
//                       • Team of 5 on-site: 1 chef, 1 butler, 2 caretakers, 1
//                       villa manager
//                     </p>
//                     <p className="flex items-start">
//                       • Property manager assistance throughout your stay
//                     </p>
//                   </div>
//                 </div>

//                 <div className=" self-end -mr-24 sm:-mr-40 relative mt-10 mb-10">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/964a5299-9327-40d8-4533-3cd1405bb100/public" //Tao_ourServices_5.webp
//                     alt="Indoor bar area with seating"
//                     className="w-[55vh] sm:w-[70vh] h-[70vh] sm:h-[80vh] object-cover"
//                   />
//                 </div>
//               </div>
//             </div>
//           </section>

//           {/* section 4 */}
//           <div className="bg-[#f5f2f0]">
//             <div
//               ref={addToRefs}
//               className="text-left text-[13px] space-y-10 text-[#948A78] ml-[12vh] sm:ml-[35vh] sm:w-[250px] items-center"
//             >
//               <h2 className="text-[20px] tracking-wide text-right mb-2 -ml-10 sm:ml-7 w-[100px] ">
//                 Inclusions
//               </h2>

//               <div className="leading-relaxed text-[13px] space-y-8 text-left sm:w-[270px] w-[200px] ml-[5vh] sm:ml-24">
//                 <p className="mb-4">• Breakfast spread included daily</p>
//                 <p>• 2 Innovas or 3 small cars for airport transfer</p>
//                 <p>
//                   • Full-day chef service (groceries for meals other than
//                   breakfast at actuals)
//                 </p>
//               </div>
//             </div>
//           </div>
//           {/* section 5 */}

//           <section
//             id="section4"
//             className="relative z-20 flex flex-col items-center justify-center w-full bg-[#f5f2f0]"
//           >
//             <div className="w-full flex justify-center mt-24">
//               <img
//                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/1902f637-2936-4eeb-3894-b522ca77f200/public" //Tao_ourServices_6.webp
//                 alt="Modern Architecture"
//                 className="w-full h-auto object-cover transition-all duration-500"
//               />
//             </div>
//           </section>

//           {/* section 6 */}
//           <div className="bg-[#f5f2f0] h-20 pt-10">
//             <div
//               ref={addToRefs}
//               className=" text-[13px] space-y-3 text-[#948A78] ml-5 sm:w-[250px]"
//             >
//               <h2 className="text-[13px] tracking-[0.20em] text-left mt-20 w-[300px] uppercase">
//                 our experiences
//               </h2>

//               <div className="leading-relaxed text-[13px] space-y-6 text-left sm:w-[400px] w-[300px]">
//                 <p className="mb-4">
//                   Your time at House of Tāo is more than a stay — it’s a
//                   collection of moments you’ll carry home. From quiet mornings
//                   to curated adventures, we help you shape experiences as unique
//                   as you are.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* section 7 */}

//           <section
//             ref={addToRefs}
//             className="bg-[#f5f2f0] text-[#948A78] py-60 px-6 sm:px-12"
//           >
//             <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-16">
//               <div className="flex-1 flex flex-col text-right">
//                 <div className="grid grid-cols-2 gap-x-4 gap-y-4 justify-items-center lg:justify-items-start text-[20px]">
//                   <p className="text-[#948A78]">In the Villa</p>
//                   <p className="text-[#BFB5A3]">
//                     Goa Through <br /> Our Eyes
//                   </p>
//                   <p className="text-[#BFB5A3]">
//                     Wellness & <br /> Retreats
//                   </p>
//                   <p className="text-[#BFB5A3]">
//                     Nature & <br /> Outdoors
//                   </p>
//                 </div>
//               </div>
//               <div className="grid grid-cols-2 items-center justify-between gap-0">
//                 <div className="w-[100vh]">
//                   <img
//                     src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9312407f-7eba-4d43-c4ec-5fcea0005b00/public" //Tao_ourPhilosophy_7.webp
//                     alt="Villa Dining Experience"
//                     className="w-[27vh] sm:w-[55vh] h-[50vh] sm:h-[70vh] object-cover -ml-6 sm:-ml-14"
//                   />
//                 </div>

//                 <div className="w-full lg:w-1/2 text-[13px] text-left space-y-4 mt-20 sm:mt-36 ml-7">
//                   <div className="space-y-4 sm:space-y-10">
//                     <p>• Signature breakfast spread by our in-house chef</p>
//                     <p>• Two-course dinners crafted to your taste</p>
//                     <p>• Floating brunch by the pool</p>
//                     <p>• Private barbecues under the stars</p>
//                   </div>
//                 </div>
//               </div>

//               <p className="sm:w-[350px] text-[#948A78] text-left text-[13px] sm:ml-[30vh] w-[250px] ml-12">
//                 Whether you’re planning your next getaway, looking for a special
//                 celebration venue, or simply curious to know more — we’d love to
//                 hear from you.
//               </p>

//               <a
//                 href="/BookNow"
//                 className="text-[#948A78] text-[13px] tracking-[0.13em] uppercase pb-10 sm:-ml-7 -ml-20 -mb-40 hover:font-bold underline decoration-[#948A78] underline-offset-[12px] decoration-1 hover:underline-offset-[5px] transition-all duration-300"
//               >
//                 BOOK YOUR STAY
//               </a>
//             </div>
//           </section>
//           <NewFooter />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default OurServices;
